import i18n from "i18next";

export function formatDuration(ms: number): string {
    const totalMinutes = Math.floor(ms / 60000);
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;
    return i18n.t("lead.form.durationDaysHoursMinutes", {
        count: days,
        day: i18n.t("lead.form.day", { count: days }),
        hour: `${hours} ${i18n.t("lead.form.hour", { count: hours })}`,
        minute: `${minutes} ${i18n.t("lead.form.minute", { count: minutes })}`,
    });
}

export function formatPhoneNumber(phone: string): string {
    const cleaned = ("" + phone).replace(/\D/g, "");
    const regex = /^(\d{3})(\d{3})(\d{4})$/;
    const match = regex.exec(cleaned);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
}
